import { Anchor } from '@/components/ui/Anchor'
import { trackMarketingCta } from '@/lib/analytics'
import { Reveal } from './Reveal'

const PRODUCTS = [
  {
    key: 'cfo',
    label: 'Cai CFO',
    href: '/cfo',
    body: 'An AI CFO that keeps an eye on your money and helps you make the big decisions.',
  },
  {
    key: 'bookkeeper',
    label: 'Cai Bookkeeper',
    href: '/bookkeeper',
    body: 'Every transaction recorded, books closed monthly.',
  },
]

/** Dark "More than insurance" band pointing contractors at Cai's other products. */
export function CaiProductLinks({ ctaPrefix }: { ctaPrefix: string }) {
  return (
    <section className="bg-ink-900 border-b border-white/10 px-5.5 pt-16 pb-14">
      <Reveal className="mx-auto grid max-w-(--maxw) grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] items-start gap-16 max-lg:grid-cols-1 max-lg:gap-8">
        <div className="flex flex-col gap-3">
          <span className="eyebrow-on-dark">About Cai</span>
          <h2 className="text-2xl font-bold tracking-[-0.01em] text-white">More than insurance</h2>
          <p className="text-md text-ink-300 max-w-95 leading-relaxed text-pretty">
            Cai makes AI-powered financial technology for the businesses that build, move, and fix the world
            around us.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 max-md:grid-cols-1">
          {PRODUCTS.map((product) => (
            <Anchor
              key={product.key}
              href={product.href}
              onClick={() => trackMarketingCta(`${ctaPrefix}_product_${product.key}`)}
              className="hover:border-brand-500 flex flex-col gap-2 rounded-sm border border-white/15 p-6 no-underline transition-colors duration-150"
            >
              <span className="flex items-center justify-between gap-3 text-lg font-bold text-white">
                {product.label}
                <span aria-hidden="true" className="text-brand-500">
                  →
                </span>
              </span>
              <span className="text-md text-ink-300 leading-relaxed text-pretty">{product.body}</span>
            </Anchor>
          ))}
        </div>
      </Reveal>
    </section>
  )
}
